import React, { useState, useEffect } from "react";

import {
  Box,
  Paper,
  Grid,
  Typography,
  Button,
  TextField,
  Tooltip,
  ButtonGroup,
} from "@mui/material";

import TopViewNav from "../CommonComponents/TopViewNav";

import MapComponent from "../Dashboard/Map";

import { DetailsAction } from "../../actions/details";
import moment from "moment";
import "./responsive.css";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import "../OutdoorDuties/Report.css";
import { v4 } from "uuid";
import { companyWiseEmp } from "../../actions/Companywiseclient";
import { useSearchParams } from "react-router-dom";
import CheckinCheckoutModal from "./CheckinCheckoutModal";
import { GeofenceAction } from "../../actions/Geofence";
import GpsLocationStatus from "./GpsLocationStatus";
import { dummyGpsData, dummyGpsTime } from "./Utils";

// {
//     "userId": "146",
//     "fromDate": "2022-11-24",
//     "toDate": "2022-11-24"
// }

const Details = () => {
  const [searchParams] = useSearchParams();
  const isLiveTracking = searchParams.get("ILS");
  const [isLiveTrackingToShowChecked, setIsLiveTrackingToShowChecked] =
    useState(false);
  const [isLiveTrackCheckBoxToShow, setIsLiveTrackCheckBoxToShow] =
    useState(false);
  const [isPreviousPathCheckBoxToShow, setIsPreviousPathCheckBoxToShow] =
    useState(false);
  const [isPreviousPathToShowChecked, setIsPreviousPathToShowChecked] =
    useState(true);
  const [details, setDetails] = useState([]);
  const [distanceDetail, setDistanceDetail] = useState([]);
  console.log("details : ", details);
  const [locationTrackingDetails, setLocationTrackingDetails] = useState([]);
  const [locationTrackingDetailsV2, setLocationTrackingDetailsV2] = useState(
    [],
  );
  const [gpsLocationStatusData, setGpsLocationStatusData] = useState([]);
  const [NewClientTitle, setNewClientTitle] = React.useState("");
  const [UniqueClients, setUniqueClients] = useState("");
  const [selectOptonCustomer, setSelectOptonCustomer] = React.useState("");
  const [selectOptonSatatus, setSelectOptonSatatus] = React.useState("");
  const [isShowGPSLocationStatusActive, setIsShowGPSLocationStatusActive] =
    useState(false);
  const [isAutoDefaultMeetingEnabled, setIsAutoDefaultMeetingEnabled] =
    React.useState(false);
  const [isLiveTrackingOn, setIsLiveTrackingOn] = useState(false);
  const [liveTrackingPolyPath, setLiveTrackingPolyPath] = useState([]);
  const [liveTrackingDistance, setLiveTrackingDistance] = useState("0.00");

  const [isEnableShowActualPath, setIsEnableShowActualPath] = useState(false);
  // console.log("liveTrackingDistance : ", liveTrackingDistance);
  const liveTrackingIntervalRef = React.useRef(null);
  const topViewNavData = {
    // title: "OD Details",
    title: "View Route",
    backPath: "OD Duties",
    backPathRoute: "/outdoorduties",
  };
  const localData = JSON.parse(localStorage.getItem("data")) || {};

  const [hasGeofencePermission, setHasGeofencePermission] = useState(
    localData?.isEnableGeofenceManagement ? true : false,
  );
  const [geofenceToShow, setGeofenceToShow] = useState(
    hasGeofencePermission ? true : false,
  );
  const [userWiseGeofences, setUserWiseGeofences] = useState([]);
  console.log("userWiseGeofences : ", userWiseGeofences);

  const [openGeofenceSessionsModal, setOpenGeofenceSessionsModal] =
    useState(false);

  const [selectedGeofenceData, setSelectedGeofenceData] = useState(null);

  const [isShowLostPath, setIsShowLostPath] = useState(false);

  const handleOpenGeofenceSessionsModal = (selectedData) => {
    // setSelectedGeofenceData(selectedData);
    setSelectedGeofenceData(selectedData);
    setOpenGeofenceSessionsModal(true);
  };
  const handleCloseGeofenceSessionsModal = () => {
    setSelectedGeofenceData(null);
    setOpenGeofenceSessionsModal(false);
  };

  const handleToggleGeofenceToShow = () => {
    setGeofenceToShow((prev) => !prev);
  };

  const fetchGeofenceWithTrail = async () => {
    try {
      // 1. Get all geofences
      const geoRes = await GeofenceAction.getGeofenceList({
        companyId: localData?.hrmsCompanyId,
        ...(Boolean(details?.length > 0) && details[0]?.userId
          ? { userId: details[0]?.userId }
          : {}),
      });

      if (!geoRes || geoRes.responseCode !== 200) return;

      const geofenceArr = Boolean(geoRes?.data?.length > 0)
        ? geoRes?.data?.map((item, index) => ({
            ...item,
            coordinatesDTOList: [
              {
                id: index + 1,
                latitude: item?.latitude,
                longitude: item?.longitude,
                color: item?.color,
                geofenceType: item?.geofenceType,
                name: item?.name,
                radius: item?.radius,
                zoomLevel: item?.zoomLevel,
                trailData: [],
              },
            ],
          }))
        : [];

      // 2. If geofence exists → get trails
      if (geofenceArr.length > 0) {
        const trailRes = await GeofenceAction.getGeofencesTrailData({
          companyId: localData?.hrmsCompanyId,
          ...(Boolean(details?.length > 0) && details[0]?.userId
            ? { userId: details[0]?.userId }
            : {}),
        });

        if (trailRes && trailRes.responseCode === 200) {
          const trailArr = trailRes?.data || [];

          // 3. Merge logic
          const mergedArr = geofenceArr
            .map((geoItem) => {
              const matchedTrail = trailArr.find(
                (trailItem) => trailItem?.geofenceId === geoItem?.id,
              );

              return {
                ...geoItem,
                coordinatesDTOList: [
                  {
                    ...geoItem?.coordinatesDTOList[0],
                    trailData: matchedTrail?.trailData || [],
                  },
                ],
              };
            })
            ?.flatMap((updtItem) => updtItem?.coordinatesDTOList);

          setUserWiseGeofences(mergedArr);
          return;
        }
      }

      // fallback if no trail data
      setUserWiseGeofences(
        geofenceArr?.flatMap((updtItem) => updtItem?.coordinatesDTOList),
      );
    } catch (err) {
      console.log("Error in fetching geofence + trail:", err);
    }
  };

  const getLostDistanceDetails = async () => {
    const singleDetail = JSON.parse(localStorage.getItem("singleDetail"));
    const hrmsUserId = JSON.parse(localStorage.getItem("data"))?.hrmsUserId;
    singleDetail.hrmsUserId = hrmsUserId;
    singleDetail.companyId = JSON.parse(
      localStorage.getItem("data"),
    )?.hrmsCompanyId;
    singleDetail.locationTrackingFrequency = JSON.parse(
      localStorage.getItem("data"),
    ).locationTrackingFrequency;
    const res = await DetailsAction.fetchLostDistanceDetails(singleDetail);
    if (res !== null) {
      if (res.responseCode === 200 && res.data?.length > 0) {
        return res.data;
      } else {
        return [];
      }
    } else {
      return [];
    }
  };

  const getDistanceDetails = async () => {
    const singleDetail = JSON.parse(localStorage.getItem("singleDetail"));
    console.log(singleDetail, "singleDetail");
    const hrmsUserId = JSON.parse(localStorage.getItem("data"))?.hrmsUserId;
    singleDetail.hrmsUserId = hrmsUserId;
    singleDetail.companyId = JSON.parse(
      localStorage.getItem("data"),
    )?.hrmsCompanyId;
    singleDetail.locationTrackingFrequency = JSON.parse(
      localStorage.getItem("data"),
    ).locationTrackingFrequency;
    const res = await DetailsAction.fetchDistanceDetails(singleDetail);
    if (res !== null) {
      if (res.responseCode === 200 && res.data?.dataList?.length > 0) {
        const lostDistanceDetails = await getLostDistanceDetails(
          res.data.dataList[0]?.hrmsUserId,
        );
        // debugger;
        setDetails(res.data && res.data.dataList && res.data.dataList);
        setDistanceDetail(res.data);
        const locationTrackingDetailsToSet = [];
        const locationTrackingDetailsV2 = [];

        function transform(data) {
          let totalMinutes = 0;
          let autoDetectMinutes = 0;
          let manualDetectMinutes = 0;

          const result = data
            ?.map((pair) => {
              if (pair.length < 2) return null;

              const start = moment.utc(pair[0].isLocationDetectedTime);
              const end = moment.utc(pair[1].isLocationDetectedTime);

              const minutes = end.diff(start, "minutes");

              // Overall total
              totalMinutes += minutes;

              // Auto / Manual total
              if (pair[0].isLostAutoDetect === true) {
                autoDetectMinutes += minutes;
              } else {
                manualDetectMinutes += minutes;
              }

              return {
                time: `${start.local().format("h:mm A")} - ${end
                  .local()
                  .format("h:mm A")}`,
                hours: Math.floor(minutes / 60),
                minutes: minutes % 60,
                duration: `${Math.floor(minutes / 60)}h ${minutes % 60}m`,
                isLostAutoDetect: pair[0].isLostAutoDetect,
              };
            })
            .filter(Boolean);

          // Helper function
          const formatDuration = (minutes) => ({
            hours: Math.floor(minutes / 60),
            minutes: minutes % 60,
            duration: `${Math.floor(minutes / 60)}h ${minutes % 60}m`,
          });

          const total = formatDuration(totalMinutes);
          const autoDetect = formatDuration(autoDetectMinutes);
          const manualDetect = formatDuration(manualDetectMinutes);

          return {
            data: result,

            // Overall
            totalHours: total.hours,
            totalMinutes: total.minutes,
            totalDuration: total.duration,

            // Auto Detect
            autoDetectTotalHours: autoDetect.hours,
            autoDetectMinutes: autoDetect.minutes,
            autoDetectDuration: autoDetect.duration,

            // Manual Detect
            manuaDetectTotalHours: manualDetect.hours,
            manuaDetectMinutes: manualDetect.minutes,
            manuaDetectDuration: manualDetect.duration,
          };
        }
        res?.data?.dataList?.forEach((od) => {
          const result = transform(lostDistanceDetails) || [];
          console.log(result);
          const startTime =
            od?.createdDate && moment(od?.createdDate).format("h:mm A");
          const endTime = od?.date && moment(od?.date).format("h:mm A");
          setGpsLocationStatusData(
            ...gpsLocationStatusData,
            lostDistanceDetails,
          );
          const finalData = [
            {
              time: startTime,
              isGreen: true,
              startTime: od?.createdDate && moment(od?.createdDate),
            },
            ...(result?.data ?? []),
            {
              time: endTime,
              isGreen: true,
              endTime: od?.date && moment(od?.date),
            },
          ];
          setLocationTrackingDetailsV2((prev) => [...prev, ...finalData]);

          const locationArr = [];
          const objToPush = {
            midPointArr: [],
            isLocationDetected: false,
          };
          od?.locationTrackingDetails?.forEach((location, locationIndex) => {
            if (locationIndex === 0) {
              // objToPush.midPointArr.push(location.isLocationDetectedTime);
              objToPush.midPointArr.push(
                convertTo12HourFormat(location.isLocationDetectedTime),
              );
              objToPush.isLocationDetected = location.isLocationDetected;
            } else {
              if (
                location.isLocationDetected === objToPush.isLocationDetected
              ) {
                // objToPush.midPointArr.push(location.isLocationDetectedTime);
                objToPush.midPointArr.push(
                  convertTo12HourFormat(location.isLocationDetectedTime),
                );
              } else {
                locationArr.push({ ...objToPush });
                // objToPush.midPointArr = [location.isLocationDetectedTime];
                objToPush.midPointArr = [
                  convertTo12HourFormat(location.isLocationDetectedTime),
                ];
                objToPush.isLocationDetected = location.isLocationDetected;
              }
            }
          });
          if (Boolean(objToPush.midPointArr.length)) {
            locationArr.push({ ...objToPush }); // for last sequence
          }
          if (Boolean(locationArr.length)) {
            locationTrackingDetailsToSet.push(locationArr);
          }
        });
        setLocationTrackingDetails(locationTrackingDetailsToSet);
      }
    }
  };

  const fetchHederTitle = () => {
    const Templatedata = JSON.parse(localStorage.getItem("Templatedata"));
    const NewClient =
      Templatedata &&
      Templatedata !== null &&
      Templatedata.filter((val) => {
        if (val.actualName === "New Client") {
          return setNewClientTitle(val.displayName);
        }
      });
    const NewClientCount =
      Templatedata &&
      Templatedata !== null &&
      Templatedata.filter((val) => {
        if (val.actualName === "Unique Clients") {
          return setUniqueClients(val.displayName);
        }
      });
  };

  let startDate = details && details[0]?.createdDate;

  console.log(moment(startDate).format("DD/MM/YYYY"));

  const fetchClientBaseEmpForDetails = () => {
    const companyId = JSON.parse(localStorage.getItem("data")).hrmsCompanyId;
    const data = {
      companyId: companyId ? companyId : null,
    };
    companyWiseEmp.fetchCompnyWiseUpdate(data).then((response) => {
      if (response !== null && response.responseCode === 200) {
        setIsEnableShowActualPath(
          response.data?.find(
            (x) => x.hrmsConfigurationName === "SHOW_ACTUAL_PATH",
          )?.isEnable || false,
        );
        const showGPSLocationStatusToSet =
          response.data &&
          response.data.filter(
            (val) => val.hrmsConfigurationName === "GPS_LOCATION_STATUS",
          );
        const isAutoDefaultMeetingEnabledToSet =
          response.data &&
          response.data.filter(
            (val) =>
              val.hrmsConfigurationName === "DEFAULT_MEETING_CONFIGURATION",
          );
        setIsShowGPSLocationStatusActive(
          showGPSLocationStatusToSet && showGPSLocationStatusToSet.length > 0
            ? showGPSLocationStatusToSet[0].isEnable === true
              ? true
              : false
            : false,
        );
        setIsAutoDefaultMeetingEnabled(
          isAutoDefaultMeetingEnabledToSet &&
            isAutoDefaultMeetingEnabledToSet.length > 0
            ? isAutoDefaultMeetingEnabledToSet[0].isEnable === true
              ? true
              : false
            : false,
        );
      }
    });
  };

  const fetchGetDistanceThroughCoordinates = async () => {
    const paylaod = { coordinates: liveTrackingPolyPath };
    const res = await DetailsAction.getDistanceThroughCoordinates(paylaod);
    if (res !== null) {
      if (res.responseCode === 200) {
        // debugger;
        setLiveTrackingDistance(res?.data || "0.00");
      }
    }
  };

  useEffect(() => {
    fetchHederTitle();
    getDistanceDetails();
    fetchClientBaseEmpForDetails();
  }, []);

  const handleChangeIsLiveTrackingToShowChecked = (isChecked) => {
    setIsLiveTrackingToShowChecked(isChecked || false);
  };

  const handleChangeIsPreviousPathToShowChecked = (isChecked) => {
    setIsPreviousPathToShowChecked(isChecked || false);
  };

  // useEffect(() => {
  //   const loggedInUserData = localStorage.getItem("data");
  //   let parsedLoggedInUserData = null;
  //   if (loggedInUserData) {
  //     parsedLoggedInUserData = JSON.parse(loggedInUserData);
  //   }

  //   const userDataForLiveTracking = localStorage.getItem(
  //     "userDataForLiveTracking"
  //   );
  //   let parsedUserDataForLiveTracking = null;
  //   if (userDataForLiveTracking) {
  //     parsedUserDataForLiveTracking = JSON.parse(userDataForLiveTracking);
  //   }
  //   const isTrackingEnabled = Boolean(
  //     isLiveTracking === "true" &&
  //       parsedLoggedInUserData?.enableLiveTracking === true &&
  //       parsedUserDataForLiveTracking?.isODOn === true
  //   )
  //     ? true
  //     : false;
  //   setIsLiveTrackCheckBoxToShow(isTrackingEnabled);
  //   setIsLiveTrackingToShowChecked(isTrackingEnabled);
  //   setIsPreviousPathCheckBoxToShow(isTrackingEnabled);
  //   setIsPreviousPathToShowChecked(!isTrackingEnabled);
  // }, [isLiveTracking]);

  useEffect(() => {
    const loggedInUserData = localStorage.getItem("data");
    let parsedLoggedInUserData = null;
    if (loggedInUserData) {
      parsedLoggedInUserData = JSON.parse(loggedInUserData);
    }

    const userDataForLiveTracking = localStorage.getItem(
      "userDataForLiveTracking",
    );
    let parsedUserDataForLiveTracking = null;
    if (userDataForLiveTracking) {
      parsedUserDataForLiveTracking = JSON.parse(userDataForLiveTracking);
    }
    const isTrackingEnabled = Boolean(
      isLiveTracking === "true" &&
      parsedLoggedInUserData?.enableLiveTracking === true &&
      parsedUserDataForLiveTracking?.isODOn === true,
    )
      ? true
      : false;
    setIsLiveTrackingOn(isTrackingEnabled);
  }, [isLiveTracking]);

  useEffect(() => {
    if (isLiveTrackingOn && Boolean(details?.length > 0)) {
      const allLocations = [];

      details?.forEach((detail) => {
        const trackHistoryList = detail?.usersOdLocationTrackHistoryDtoList;

        if (Array.isArray(trackHistoryList)) {
          trackHistoryList.forEach((location) => {
            const lat = location?.latitude;
            const lng = location?.longitude;

            if (typeof lat === "number" && typeof lng === "number") {
              allLocations.push({ lat, lng });
            }
          });
        }
      });

      setLiveTrackingPolyPath(allLocations);
    } else {
      setLiveTrackingPolyPath([]);
    }
  }, [isLiveTrackingOn, details]);

  useEffect(() => {
    if (Boolean(liveTrackingPolyPath?.length > 0)) {
      fetchGetDistanceThroughCoordinates();
    }
  }, [liveTrackingPolyPath]);

  useEffect(() => {
    if (liveTrackingIntervalRef.current) {
      clearInterval(liveTrackingIntervalRef.current);
      liveTrackingIntervalRef.current = null;
    }

    if (!isLiveTrackingOn) {
      return;
    }

    let parsedData = null;
    try {
      const rawData = localStorage.getItem("data");
      if (rawData) parsedData = JSON.parse(rawData);
    } catch (err) {
      console.error("Failed to parse loggedInUserData:", err);
      return;
    }

    const frequencyInMinutes = parsedData?.locationTrackingFrequency;

    if (typeof frequencyInMinutes === "number" && frequencyInMinutes > 0) {
      const frequencyInMs = frequencyInMinutes * 60 * 1000;

      liveTrackingIntervalRef.current = setInterval(
        getDistanceDetails,
        frequencyInMs,
      );
    } else {
      console.warn(
        "No valid locationTrackingFrequency. Skipping tracking call.",
      );
    }

    return () => {
      if (liveTrackingIntervalRef.current) {
        clearInterval(liveTrackingIntervalRef.current);
        liveTrackingIntervalRef.current = null;
      }
    };
  }, [isLiveTrackingOn]);

  useEffect(() => {
    if (Boolean(details?.length > 0) && details[0]?.userId) {
      fetchGeofenceWithTrail();
    }
  }, [details]);

  console.log(locationTrackingDetailsV2);

  return (
    <main className="contents__root">
      <Grid container spacing={2}>
        <Grid
          item
          xs={12}
          sx={{
            display: "flex",
            alignItems: "end",
            justifyContent: "space-between",
          }}
        >
          <TopViewNav
            topViewNavData={topViewNavData}
            isDetails={true}
            ViewEmpCount={true}
          />
        </Grid>
        <Grid item xs={12}>
          <Box
            className="mein_view"
            component={Paper}
            sx={{
              padding: "0.75rem",
            }}
          >
            <Grid container spacing={1}>
              <Grid item xs={12} className="details_page">
                <Box className="top_table_status view_map">
                  <Grid container spacing={2}>
                    <Grid item xs={12} md={12} lg={4} pr={1}>
                      <Box
                        sx={{
                          display: "flex",
                          gap: "6px",
                        }}
                      >
                        <div className="field_box field_toggle">
                          <div>
                            {details && details[0]?.userName}{" "}
                            {details && details[0]?.empCode
                              ? `(${details && details[0].empCode})`
                              : null}
                          </div>
                        </div>
                        <div className="date_container">
                          <span className="title">Date</span>
                          <span className="date">
                            {moment(startDate).format("DD/MM/YYYY")}
                          </span>
                        </div>
                        {/* <div className="field_box calender">
                          <span>to</span>
                          <TextField
                            name="fromDate"
                            type="date"
                            size="small"
                            variant="outlined"
                            value={startDate}
                          />
                        </div> */}
                      </Box>
                    </Grid>
                    <Grid item xs={12} md={12} lg={8}>
                      <Box
                        className="right_status_colors"
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          height: "100%",
                        }}
                      >
                        <div
                          className="field_toggle"
                          style={{
                            backgroundColor: "#F4ECB5",
                          }}
                        >
                          <span>Total Meetings</span>
                          <span className="count_bx">
                            {/* {details[0]?.clientCommunicationDtoList.length} */}
                            {/* {details &&
                            details[0] &&
                            details &&
                            details[0].clientCommunicationDtoList &&
                            details &&
                            details[0].clientCommunicationDtoList.length
                              ? details && details[0].totalVisit
                              : "N/A"} */}
                            {Boolean(details) && Boolean(details.length)
                              ? details.reduce((prev, curr) => {
                                  if (curr.totalVisit) {
                                    return prev + curr.totalVisit;
                                  }
                                  return prev;
                                }, 0)
                              : "N/A"}
                          </span>
                        </div>
                        <div
                          className="field_toggle"
                          style={{
                            backgroundColor: "#E1EDC4",
                          }}
                        >
                          <span>
                            {localData?.isClientNameChanged
                              ? (
                                  (NewClientTitle !== ""
                                    ? NewClientTitle
                                    : "New Clients") + ""
                                )?.replace(
                                  /client/gi,
                                  localData?.changedClientFieldName || "Client",
                                )
                              : NewClientTitle !== ""
                                ? NewClientTitle
                                : "New Clients"}
                          </span>
                          <span className="count_bx">
                            {/* {details[0]?.totalClientNewCommunication} */}
                            {/* {details &&
                            details[0] &&
                            details &&
                            details[0].totalClientNewCommunication
                              ? details &&
                                details[0].totalClientNewCommunication
                              : "N/A"} */}
                            {Boolean(details) && Boolean(details.length)
                              ? details.reduce((prev, curr) => {
                                  if (curr.totalClientNewCommunication) {
                                    return (
                                      prev + curr.totalClientNewCommunication
                                    );
                                  }
                                  return prev;
                                }, 0)
                              : "N/A"}
                          </span>
                        </div>
                        <div
                          className="field_toggle"
                          style={{
                            backgroundColor: "#ECD0EF",
                          }}
                        >
                          <span>
                            {localData?.isClientNameChanged
                              ? (
                                  (UniqueClients !== ""
                                    ? UniqueClients
                                    : "Unique Clients") + ""
                                )?.replace(
                                  /client/gi,
                                  localData?.changedClientFieldName || "Client",
                                )
                              : UniqueClients !== ""
                                ? UniqueClients
                                : "Unique Clients"}
                          </span>
                          <span className="count_bx">
                            {/* {details[0] && DETAIL?.totalUniqueClient} */}
                            {/* {details &&
                            details[0] &&
                            details &&
                            details[0].totalUniqueClient
                              ? details && details[0].totalUniqueClient
                              : "N/A"} */}
                            {Boolean(details) && Boolean(details.length)
                              ? details.reduce((prev, curr) => {
                                  if (curr.totalUniqueClient) {
                                    return prev + curr.totalUniqueClient;
                                  }
                                  return prev;
                                }, 0)
                              : "N/A"}
                          </span>
                        </div>
                        <div
                          className="field_toggle"
                          style={{
                            backgroundColor: "#ECD0EF",
                          }}
                        >
                          <span>Total Distance(Kms) </span>
                          <span className="count_bx">
                            {/* {details &&
                            details[0] &&
                            details &&
                            details[0].totalDistance
                              ? details && details[0].totalDistance.toFixed(2)
                              : "N/A"} */}
                            {/* {Boolean(details) && Boolean(details.length)
                              ? details
                                  .reduce((prev, curr) => {
                                    if (curr.totalDistance) {
                                      return prev + curr.totalDistance;
                                    }
                                    return prev;
                                  }, 0)
                                  .toFixed(2)
                              : "N/A"} */}

                            {isLiveTrackingOn ? (
                              liveTrackingDistance || "N/A"
                            ) : (
                              <>
                                {Boolean(details) && Boolean(details.length)
                                  ? details
                                      .reduce((prev, curr) => {
                                        if (curr.totalDistance) {
                                          return prev + curr.totalDistance;
                                        }
                                        return prev;
                                      }, 0)
                                      .toFixed(2)
                                  : "N/A"}
                              </>
                            )}
                          </span>
                        </div>
                        <div
                          className="field_toggle"
                          style={{
                            backgroundColor: "#ECD0EF",
                          }}
                        >
                          <span>Daily Distance Fare (₹)</span>
                          <span className="count_bx">
                            {/* {details[0]?.totalAmountForOd.toFixed() || "N/A"} */}
                            {/* {details &&
                            details[0] &&
                            details &&
                            details[0].totalAmountForOd
                              ? details && details[0].totalAmountForOd.toFixed()
                              : "N/A"} */}
                            {/* =================== */}
                            {/* {Boolean(details) && Boolean(details.length)
                              ? details
                                  .reduce((prev, curr) => {
                                    if (curr.totalAmountForOd) {
                                      return prev + curr.totalAmountForOd;
                                    }
                                    return prev;
                                  }, 0)
                                  .toFixed()
                              : "N/A"} */}

                            {isLiveTrackingOn ? (
                              "0.00" || "N/A"
                            ) : (
                              <>
                                {Boolean(details) && Boolean(details.length)
                                  ? details
                                      .reduce((prev, curr) => {
                                        if (curr.totalAmountForOd) {
                                          return prev + curr.totalAmountForOd;
                                        }
                                        return prev;
                                      }, 0)
                                      .toFixed(2)
                                  : "N/A"}
                              </>
                            )}
                          </span>
                        </div>
                      </Box>
                    </Grid>
                    {Boolean(locationTrackingDetailsV2) &&
                      Boolean(isShowGPSLocationStatusActive) && (
                        <Grid item xs={12}>
                          <GpsLocationStatus
                            // data={dummyGpsData}
                            // time={dummyGpsTime}
                            data={gpsLocationStatusData}
                            time={locationTrackingDetailsV2}
                            layout={{
                              itemsPerRow: 4, // how many nodes before it wraps to the next row
                              rowHeight: 150, // vertical spacing between rows
                              colWidth: 220, // horizontal spacing between nodes
                              nodeRadius: 28, // size of the colored circle markers
                              timeGap: 5, // gap between circle and the time label above it
                              chipGap: 5, // gap between circle and the status chip below it
                              padding: 30, // breathing room around the whole diagram
                              startX: 90, // x of the first node
                              row0Y: 90, // y of the first row
                            }}
                          />
                          {/* <Box sx={{ display: "flex", gap: 1 }}>
                            {Boolean(locationTrackingDetailsV2.length) && (
                              <Button
                                variant="outlined"
                                size="small"
                                sx={{
                                  textTransform: "none",
                                  flexWrap: "nowrap",
                                }}
                              >
                                GPS Location Status
                              </Button>
                            )}                            
                            <Box
                              sx={{
                                display: "flex",
                                flexWrap: "wrap",
                                rowGap: 0.5,
                                overflow: "auto",
                                flexGrow: 1,
                              }}
                            >
                              <ButtonGroup
                                sx={{
                                  gap: 0.5, // 8px between buttons
                                  flexWrap: "wrap",
                                }}
                              >
                                {locationTrackingDetailsV2.map(
                                  (locationDetail) => {
                                    return (
                                      <Button
                                        color={
                                          locationDetail.isGreen
                                            ? "success"
                                            : "error"
                                        }
                                        variant="contained"
                                        size="small"
                                        sx={{ whiteSpace: "nowrap" }}
                                      >
                                        {locationDetail.time}
                                      </Button>
                                    );
                                  },
                                )}
                              </ButtonGroup>
                            </Box>
                          </Box> */}
                        </Grid>
                      )}
                    {false &&
                      Boolean(true || isShowGPSLocationStatusActive) && (
                        <Grid item xs={12}>
                          <Box sx={{ display: "flex", gap: 1 }}>
                            {Boolean(locationTrackingDetails.length) && (
                              <Button
                                variant="outlined"
                                size="small"
                                sx={{
                                  textTransform: "none",
                                  flexWrap: "nowrap",
                                }}
                              >
                                GPS Location Status
                              </Button>
                            )}
                            <Box
                              sx={{
                                display: "flex",
                                flexWrap: "wrap",
                                rowGap: 0.5,
                                overflow: "auto",
                                flexGrow: 1,
                              }}
                            >
                              <ButtonGroup
                                sx={{
                                  gap: 0.5, // 8px between buttons
                                  flexWrap: "wrap",
                                }}
                              >
                                {locationTrackingDetails.map(
                                  (locationDetail) => {
                                    const trackingDetails =
                                      locationDetail || [];

                                    let locationDetectedData = [];

                                    if (trackingDetails.length === 1) {
                                      locationDetectedData = [
                                        trackingDetails[0],
                                      ];
                                    } else if (trackingDetails.length > 1) {
                                      const first = trackingDetails[0];
                                      if (first?.midPointArr?.length > 0) {
                                        first.midPointArr = [
                                          first.midPointArr[0],
                                        ];
                                      }
                                      const last =
                                        trackingDetails[
                                          trackingDetails.length - 1
                                        ];
                                      if (last?.midPointArr?.length > 0) {
                                        last.midPointArr = [
                                          last.midPointArr[
                                            last.midPointArr.length - 1
                                          ],
                                        ];
                                      }
                                      last.isLocationDetected = true; // Ensure the last item is marked as detected

                                      const middle = trackingDetails
                                        .slice(1, -1)
                                        .filter(
                                          (item) =>
                                            item.isLocationDetected === false,
                                        );

                                      locationDetectedData = [
                                        first,
                                        ...middle,
                                        last,
                                      ];
                                    }
                                    return (
                                      <React.Fragment key={v4()}>
                                        {locationDetectedData.map((obj) => {
                                          return (
                                            <Tooltip
                                              title={
                                                obj.midPointArr &&
                                                obj.midPointArr?.join(", ")
                                              }
                                              key={v4()}
                                              arrow
                                            >
                                              <Button
                                                color={
                                                  obj.isLocationDetected
                                                    ? "success"
                                                    : "error"
                                                }
                                                variant="contained"
                                                size="small"
                                                sx={{ whiteSpace: "nowrap" }}
                                              >
                                                {obj.midPointArr.length > 1
                                                  ? `${obj.midPointArr[0]} - ${
                                                      obj.midPointArr[
                                                        obj.midPointArr.length -
                                                          1
                                                      ]
                                                    }`
                                                  : obj.midPointArr[0]}
                                              </Button>
                                            </Tooltip>
                                          );
                                        })}
                                      </React.Fragment>
                                    );
                                  },
                                )}
                              </ButtonGroup>
                              {/* {locationTrackingDetails.map((locationDetail) => {
                              return (
                                <React.Fragment key={v4()}>
                                  {locationDetail.map((obj) => {
                                    return (
                                      <Tooltip
                                        // title={obj.midPointArr.join(", ")}
                                        title={
                                          obj.midPointArr.length > 1
                                            ? `${obj.midPointArr[0]} - ${
                                                obj.midPointArr[
                                                  obj.midPointArr.length - 1
                                                ]
                                              }`
                                            : obj.midPointArr[0]
                                        }
                                        key={v4()}
                                        arrow
                                      >
                                        <Box
                                          sx={{
                                            background: (theme) =>
                                              obj.isLocationDetected
                                                ? theme.palette.success.main
                                                : theme.palette.error.main,
                                            heigth: "100%",
                                            width:
                                              (obj?.midPointArr?.length || 0) *
                                                4 +
                                              "px",
                                          }}
                                        />
                                      </Tooltip>
                                    );
                                  })}
                                </React.Fragment>
                              );
                            })} */}
                            </Box>
                          </Box>
                        </Grid>
                      )}
                  </Grid>
                </Box>
                <MapComponent
                  isDetails={true}
                  details={details && details}
                  isAutoDefaultMeetingEnabled={isAutoDefaultMeetingEnabled}
                  isLiveTrackingOn={isLiveTrackingOn}
                  liveTrackingPolyPath={liveTrackingPolyPath || []}
                  isLiveTrackCheckBoxToShow={isLiveTrackCheckBoxToShow}
                  isLiveTrackingToShowChecked={isLiveTrackingToShowChecked}
                  handleChangeIsLiveTrackingToShowChecked={
                    handleChangeIsLiveTrackingToShowChecked
                  }
                  isPreviousPathCheckBoxToShow={isPreviousPathCheckBoxToShow}
                  isPreviousPathToShowChecked={isPreviousPathToShowChecked}
                  handleChangeIsPreviousPathToShowChecked={
                    handleChangeIsPreviousPathToShowChecked
                  }
                  userWiseGeofences={userWiseGeofences}
                  hasGeofencePermission={hasGeofencePermission}
                  geofenceToShow={geofenceToShow}
                  handleToggleGeofenceToShow={handleToggleGeofenceToShow}
                  handleOpenGeofenceSessionsModal={
                    handleOpenGeofenceSessionsModal
                  }
                  isShowLostPath={isShowLostPath}
                  setIsShowLostPath={setIsShowLostPath}
                  distanceDetail={distanceDetail}
                  isEnableShowActualPath={isEnableShowActualPath}
                />
                <CheckinCheckoutModal
                  open={openGeofenceSessionsModal}
                  onClose={handleCloseGeofenceSessionsModal}
                  geofenceData={selectedGeofenceData}
                  geofenceName={selectedGeofenceData?.name || ""}
                />
              </Grid>
            </Grid>
          </Box>
        </Grid>
      </Grid>
    </main>
  );
};

function convertTo12HourFormat(time24) {
  let [hours, minutes] = time24.split(":");

  hours = parseInt(hours);

  const period = hours >= 12 ? "PM" : "AM";

  hours = hours % 12;

  if (hours === 0) {
    hours = 12;
  }
  return `${hours}:${minutes} ${period}`;
}

export default Details;
